import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import "./UserList.css"

const UsersList = () => {
  document.title = "Users | Uma Classes";

  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://uma.aasmo.in/api/admin/getall-users', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { search, page } // Pass search and page as query params
      });
  
      // Sort users by the 'createdAt' date in descending order
      const sortedUsers = response.users?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  
      setUsers(sortedUsers || []);
      setTotalPages(response.totalPages);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };
  
  

  useEffect(() => {
    fetchUsers();
  }, [search, page]); // Fetch users whenever search term or page changes

  const toggleModal = () => setModal(!modal);

  const handleDelete = (userId) => {
    setUserIdToDelete(userId);
    toggleModal();
  };

  const confirmDelete = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`https://uma.aasmo.in/api/admin/delete-user/${userIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setUsers(users.filter(user => user._id !== userIdToDelete));
      toggleModal();
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  const handleEdit = (userId) => {
    navigate(`/edit-users/${userId}`);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1); // Reset to first page on search
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Users" breadcrumbItem="All" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">All Users</h4>
                  <p className="card-title-desc">Below are all registered users</p>

                  <Input
                    type="text"
                    placeholder="Search by User Name"
                    value={search}
                    onChange={handleSearch}
                    className="col-md-6 mb-3"
                  />

                  <div className="table-responsive">
                    <table className="table mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Image</th>
                          <th>Full Name</th>
                          <th>Email</th>
                          <th>Mobile Number</th>
                          <th>Standard</th>
                          <th>Class</th>
                          <th>Latest Course</th>
                          <th>Course Registration Date</th>
                          <th>Course Expiry Date</th>
                         
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users.length > 0 ? (
                          users.map((user, index) => {
                            // Get the latest course based on registration date
                            const latestCourse = user.courses.sort((a, b) => new Date(b.registrationDate) - new Date(a.registrationDate))[0];

                            return (
                              <tr key={user._id}>
                                <th scope="row">{(page - 1) * 10 + index + 1}</th>
                                <td>
                                  {user?.image ? (
                                    <img
                                      src={user.image}
                                      alt={user.name}
                                      style={{ width: "50px", height: "auto" }}
                                    />
                                  ) : (
                                    "No image"
                                  )}
                                </td>
                                <td className="nowrap">{user?.name}</td>
                                <td className="nowrap">{user?.email}</td>
                                <td className="nowrap">{user?.phoneNumber}</td>
                                <td className="nowrap">{user?.standard}</td>
                                <td className="nowrap">{user?.class}</td>
                                <td className="nowrap">
  {latestCourse?.courseId ? latestCourse.courseId.name : 'No Courses'}
</td>

                              
                                <td className="nowrap">
  {latestCourse?.courseId ? moment(latestCourse.registrationDate).format('MMMM Do, YYYY') : 'N/A'}
</td>
<td className="nowrap">
  {latestCourse?.courseId ? moment(latestCourse.expiryDate).format('MMMM Do, YYYY') : 'N/A'}
</td>

                                <td>
                                  <i className="dripicons-document-edit" onClick={() => handleEdit(user._id)} />{" "}
                                  <i className="dripicons-document-delete" onClick={() => handleDelete(user._id)} />{" "}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">No users found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <br></br>
                  {/* Pagination Controls */}
                  <div className="pagination-controls" style={{ textAlign: "center" }}>
                    {[...Array(totalPages)].map((_, index) => (
                      <Button key={index} onClick={() => changePage(index + 1)} disabled={page === index + 1}>
                        {index + 1}
                      </Button>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Delete Confirmation Modal */}
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this user?
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal}>Cancel</Button>
            <Button color="danger" onClick={confirmDelete}>Delete</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default UsersList;
